import React from "react";
import Footer from "../components/footer/Footer";
import Header from "../components/header/Header";
import Contents from "../components/pages/editProfile/Contents";

const EditProfile = () => {
    return (
        <>
            <Header />
            <Contents />
            <Footer />
        </>
    );
}

export default EditProfile;